module.exports = __webpack_public_path__ + "static/media/V3.a95818be.png";